// The three pillars displayed on the home page (section "Principes").

export interface Pillar {
  num: string;
  word: string;
  title: string;
  body: string;
  meta: string;
}

export const PILLARS: Pillar[] = [
  {
    num: '01 — circulation',
    word: 'Circuler',
    title: 'cross-plateforme par défaut',
    body: "Ton fil musical traverse les plateformes. Tes amis existent, où qu'ils écoutent — Apple Music, Deezer, SoundCloud, YouTube.",
    meta: '→ ISRC · API officielles · zero scraping',
  },
  {
    num: '02 — humain',
    word: 'Humain',
    title: 'le signal humain, d’abord',
    body: "Pas d'algorithme qui choisit pour toi. Pas d'IA générative dans le fil. Le signal humain — imparfait, subjectif, contextuel — est notre matière première.",
    meta: '→ aucun feed algorithmique · aucun ranking',
  },
  {
    num: '03 — ouvert',
    word: 'Ouvert',
    title: "ton identité t'appartient",
    body: "Tu exportes tout. Tu pars quand tu veux. À terme, un protocole décentralisé que personne ne possède — ni nous, ni les plateformes.",
    meta: '→ export complet · open-source roadmap',
  },
];
